import { ref } from 'vue';
import { defineStore } from 'pinia';

export type RoutePlanViewTab = 'calendar' | 'map' | 'timeline' | 'list';

// Remembers the dispatcher's preferred route view across Rails page navigations.
// Defaults to the interactive calendar; views without a calendar tab (the applied screen)
// fall back to the map when this is the persisted value.
export const useRoutePlanViewStore = defineStore('routePlanView', () => {
  const lastTab = ref<RoutePlanViewTab>('calendar');

  return { lastTab };
}, { persist: true });
